import { useState } from "react";
import { faqs, testimonials } from "@/mocks/home";
import Reveal from "./Reveal";

const principles = [
  {
    icon: "ri-eye-line",
    title: "看得清楚",
    desc: "按时间线还原来龙去脉，不只截取片段，帮你看到完整脉络。",
  },
  {
    icon: "ri-file-list-3-line",
    title: "整得明白",
    desc: "把散落内容整理成分类合集，需要时随手就能翻到、带走。",
  },
  {
    icon: "ri-check-double-line",
    title: "核得靠谱",
    desc: "内容整理坚持多源复核，发现偏差会在合集内及时修正标注。",
  },
];

export default function AboutFaq() {
  const [active, setActive] = useState(0);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section className="bg-background-100/70 py-14 md:py-20">
      <div className="container-gua">
        {/* about + faq */}
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          <Reveal>
            <div>
              <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
                <i className="ri-quill-pen-line"></i>
                关于我们
              </span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                呱呱爆料，是一份会一直更新的吃瓜档案
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-700">
                呱呱爆料定位为全网热点合集整理与精华内容汇总平台。我们相信，热点不该只有碎片，历史不该被轻易遗忘。编辑部坚持把热门话题、综艺名场面与娱乐盘点按时间与主题归类，做成一份可检索、可回看、可打包带走的内容档案。
              </p>

              <div className="mt-7 space-y-5">
                {principles.map((p) => (
                  <div key={p.title} className="flex items-start gap-4">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                      <i className={`${p.icon} text-xl`}></i>
                    </span>
                    <div>
                      <h3 className="font-semibold text-foreground-900">{p.title}</h3>
                      <p className="mt-1 text-sm text-foreground-600">{p.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>

          <div id="faq" className="section-anchor">
            <Reveal>
              <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
                <i className="ri-question-answer-line"></i>
                常见问题
              </span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                你可能想知道的事
              </h2>

              <div className="mt-6 space-y-3">
                {faqs.map((f, idx) => {
                  const open = active === idx;
                  return (
                    <div
                      key={f.q}
                      className={`overflow-hidden rounded-lg border bg-background-50 transition ${
                        open ? "border-primary-300" : "border-background-200/80"
                      }`}
                    >
                      <button
                        type="button"
                        onClick={() => setActive(open ? -1 : idx)}
                        className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                      >
                        <span className="text-sm font-semibold text-foreground-900 md:text-base">
                          {f.q}
                        </span>
                        <span
                          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-primary-600 transition ${
                            open ? "bg-primary-100 rotate-180" : "bg-background-100"
                          }`}
                        >
                          <i className="ri-arrow-down-s-line text-xl"></i>
                        </span>
                      </button>
                      <div className={`gua-acc ${open ? "open" : ""}`}>
                        <div className="gua-acc-inner">
                          <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                            {f.a}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Reveal>
          </div>
        </div>

        {/* testimonials */}
        <div className="mt-16 md:mt-20">
          <Reveal>
            <div className="flex items-center gap-3">
              <i className="ri-star-fill text-xl text-accent-500"></i>
              <h3 className="font-heading text-lg font-bold text-foreground-950 md:text-2xl">
                老粉都在说
              </h3>
            </div>
          </Reveal>
          <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-3">
            {testimonials.map((t, idx) => (
              <Reveal key={t.name} delay={idx * 60}>
                <figure className="flex h-full flex-col justify-between rounded-lg border border-background-200/70 bg-background-50 p-6">
                  <div>
                    <div className="flex gap-0.5 text-accent-500">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-sm"></i>
                      ))}
                    </div>
                    <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                      “{t.text}”
                    </blockquote>
                  </div>
                  <figcaption className="mt-5 flex items-center gap-3">
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-200 text-secondary-800">
                      <i className="ri-user-smile-line text-xl"></i>
                    </span>
                    <div>
                      <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                      <div className="text-xs text-foreground-500">{t.role}</div>
                    </div>
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </section>
  );
}